var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main-content',[_c(_vm.selectedComponent,{tag:"component"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }